// Výběr jprl včetně zobrazení výpisu jprl
<template>
  <v-app-bar rounded="lg" absolute class="ma-1" dense extension-height="auto" style="z-index: 2">
    <v-card width="100" class="mr-1" v-if="vOddIds.length > 1">
      <v-select label="Revír" :items="vOddIds" item-text="ODD_ID" v-model="vOddId" return-object chips dense solo flat
        color="accent" hide-details="true"></v-select>
    </v-card>
    <v-card width="110" class="mr-1">
      <v-select label="Oddělení" :items="vOddId.sOdds" item-text="ODD" v-model="vOdd" return-object chips dense solo flat
        color="accent" hide-details="true" no-data-text="Není vybráno žádné Lhc."></v-select>
    </v-card>
    <v-card width="100" class="mr-1">
      <v-select label="Dílec" :items="vOdd.sDils" item-text="DIL" v-model="vDil" return-object chips dense solo flat
        color="accent" hide-details="true" no-data-text="Není vybráno žádné Lhc."></v-select>
    </v-card>
    <v-card width="100" class="mr-1">
      <v-select label="Porost" :items="vDil.sPors" item-text="POR" v-model="vPor" return-object chips dense solo flat
        color="accent" hide-details="true" no-data-text="Není vybráno žádné Lhc."></v-select>
    </v-card>

    <v-card height="40" min-width="160" class="px-1">
      <v-chip-group v-model="vJprl" active-class="accent2--text" show-arrows>
        <template v-for="Jprl in vPor.sJprls">
          <v-chip :key="Jprl.U_JID" color="colorPSK" v-if="Jprl.TYP_JPRL == 'PSK'" class="my-0">
            {{ Jprl.PSK_BZL_JP_OP }}
          </v-chip>
          <v-chip :key="Jprl.U_JID" color="colorBZL" v-else-if="Jprl.TYP_JPRL == 'BZL'" class="my-0">
            {{ Jprl.PSK_BZL_JP_OP }}
          </v-chip>
          <v-chip :key="Jprl.U_JID" color="colorJP" v-else-if="Jprl.TYP_JPRL == 'JP'" class="my-0">
            {{ Jprl.PSK_BZL_JP_OP }}
          </v-chip>
          <v-chip :key="Jprl.PSK_BZL_JP_OP" color="colorOP" v-else class="my-0">
            {{ Jprl.PSK_BZL_JP_OP }}
          </v-chip>
        </template>
      </v-chip-group>
    </v-card>

    <v-spacer></v-spacer>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" @click="vJprlViewVypis = !vJprlViewVypis" class="ml-1">
          <v-icon v-if="vJprlViewVypis" color="">mdi-clipboard-text</v-icon>
          <v-icon v-else color="">mdi-clipboard-text-off</v-icon>
        </v-btn>
      </template>
      <span>Zobrazit výpis</span>
    </v-tooltip>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" @click="vJprlViewOnMap = !vJprlViewOnMap" class="mr-1">
          <v-icon v-if="vJprlViewOnMap" color="">mdi-map-marker</v-icon>
          <v-icon v-else color="">mdi-map-marker-off</v-icon>
        </v-btn>
      </template>
      <span>Zobrazit na mapě</span>
    </v-tooltip>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-card v-bind="attrs" v-on="on" class="mx-1" color="transparent" flat width="200" v-if="true">
          <v-slider v-model="VypisZoom" class="align-center" max="120" min="50" step="1" thumb-color="accent2"
            hide-details dense>
            <template v-slot:append>
              <div v-text="VypisZoom + ' %'" class="text-no-wrap text-right mr-2" style="width: 40px"></div>
            </template>
          </v-slider>
        </v-card>
      </template>
      <span>Měřítko výpisu</span>
    </v-tooltip>

    <v-spacer></v-spacer>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" @click="VypisLight = !VypisLight" class="ml-1">
          <v-icon v-if="VypisLight" color="">mdi-sticker-text</v-icon>
          <v-icon v-else color="">mdi-sticker-text-outline</v-icon>
        </v-btn>
      </template>
      <span>Černobílý výpis</span>
    </v-tooltip>

    <v-speed-dial direction="right">
      <template v-slot:activator>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="ml-1">
              <v-icon color="">mdi-printer</v-icon></v-btn>
          </template>
          <span>Tisk vybrané jednotky</span>
        </v-tooltip>
      </template>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" fab small color="" @click="JprlPrint('printVypisLhpo_A4P')">
            <v-icon color="accent">mdi-crop-portrait</v-icon>
          </v-btn>
        </template>
        <span>Tisk A4 na výšku</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" fab small color="" @click="JprlPrint('printVypisLhpo_A4L')">
            <v-icon color="accent">mdi-crop-landscape</v-icon>
          </v-btn>
        </template>
        <span>Tisk A4 na šířku</span>
      </v-tooltip>
    </v-speed-dial>



    <v-spacer></v-spacer>

    <v-btn icon @click="VybCompClose()">
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <template v-slot:extension>
      <v-card v-if="vJprlViewVypis" rounded="lg" class="mt-1 pa-1 overflow-auto" :light="VypisLight" id="PrintAreaTiskHk">
        <div v-html="JprlVypisData" :style="{
          fontSize: (VypisZoom / 100) * 16 + 'px',
        }" :class="VypisLight ? 'CB_VypisLhpo' : ''"></div>
      </v-card>
    </template>

    <!-- Upozornění -->
    <v-dialog v-model="Alert_view" max-width="400">
      <v-alert class="pa-4 ma-0" type="error" dense icon="mdi-alert-circle-outline">{{ Alert_text }}
      </v-alert>
    </v-dialog>
  </v-app-bar>
</template>

<script>
//import JprlPokus from "../assets/temporary/seznamjprl.json";
import ServiceLhpo from "../services/ServiceLhpo";
import print from "./common/print";

export default {
  props: {
    // Jméno komponenty
    CompName: { type: String },
    // Kategorie aplikace
    AppCategory: { type: String },
    // Adresa webové služby
    AppServiceurl: { type: Object },
    // Seznam  komponent
    CompList: { type: Array },
  },
  data() {
    return {
      // Upozornění
      Alert_view: false,
      // Upozornění - text
      Alert_text: "",

      vOddIds: [],
      vOddId: Object,
      vOdd: Object,
      vDil: Object,
      vPor: Object,
      vJprl: null,
      // Zobrazení výpisu
      vJprlViewVypis: true,
      // Zoom na mapě
      vJprlViewOnMap: true,
      JprlVypisData: "",
      pokus: null,
      // Měřítko výpisu
      VypisZoom: 100,

      // Černobílý výpis
      VypisLight: false,
    };
  },

  computed: {
    // Změna vybrané komponenty podle jména
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", {
          CompName: newValue,
          SlotName: this.CompList.find((item) => item.name == newValue).slot,
        });
      },
    },

    // Vybrané Lhc - z globální proměnně
    VybLhc: function () {
      return this.$store.getters.GET_sVybLhc;
    },

    // Zda je neybrán majetek
    NevybLhcMaj: function () {
      if (this.VybLhc.MajKod == null) {
        return true;
      } else {
        return false;
      }
    },

    // Vybrané Jprl - z globální proměnně
    VybJprl: function () {
      return this.$store.getters.GET_sVybJprl;
    },

    // Dotaz z mapy - z globální proměnně
    MapQuery: function () {
      return this.$store.getters.GET_sMapQuery;
    },
  },

  watch: {
    VybLhc: function (value) {
      this.ZmenaLhc(value);
    },

    vOddIds: function (value) {
      if (value[0] !== null && typeof value[0] !== "undefined") {
        this.vOddId = value[0];
      } else {
        this.vOddId = { sOdds: [] };
      }
    },
    vOddId: function (value) {
      if (value.sOdds[0] !== null && typeof value.sOdds[0] !== "undefined") {
        this.vOdd = value.sOdds[0];
      } else {
        this.vOdd = { sDils: [] };
      }
    },
    vOdd: function (value) {
      if (value.sDils[0] !== null && typeof value.sDils[0] !== "undefined") {
        this.vDil = value.sDils[0];
      } else {
        this.vDil = { sPors: [] };
      }
    },
    vDil: function (value) {
      if (value.sPors[0] !== null && typeof value.sPors[0] !== "undefined") {
        this.vPor = value.sPors[0];
      } else {
        this.vPor = { sJprls: [] };
      }
    },
    vPor: function () {
      this.vJprl = null;
    },

    // Vybrané jprl - do globální proměnné
    // je to dělané přes globální proměnou, kdyby přišel požadavek odjinud
    vJprl: function (value) {
      if (value !== null && typeof value !== "undefined") {
        var JprlID = this.VybLhc.JidDs + "-" + this.vPor.sJprls[value].U_JID;

        this.$store.commit("SET_sVybJprl", {
          JprlID: JprlID,
          ViewVypis: this.vJprlViewVypis,
          ViewOnMap: this.vJprlViewOnMap,
        });
        return JprlID;
      }
    },

    // Vybrané jprl - změna globální proměnné
    VybJprl: function (value) {
      // Výpis, když je požadován
      if (value.ViewVypis) {
        this.NactiJprlVypis(value.JprlID);
      }
      // Zoom, když je požadován
      if (value.ViewOnMap) {
        this.NactiJprlMbr(value.JprlID);
      }
    },

    // Dotaz z mapy jprl - změna globální proměnné
    MapQuery: function (value) {
      // Výpis, když je požadován
      if (value.type == "JprlXY") {
        this.NactiBboxJprl(
          value.options.ds,
          value.epsg.slice(5),
          value.x,
          value.y
        );
      }
    },
  },

  methods: {
    // Zavře tuto komponentu
    VybCompClose: function () {
      this.$store.commit("SET_sVybComp", {
        CompName: null,
        SlotName: this.CompList.find((item) => item.name == this.CompName).slot,
      });
    },

    // WS - Seznam Jprl
    NactiLhcSeznamJprl: function (Jid, MajKod) {
      ServiceLhpo.LhcSeznamJprl(Jid, MajKod)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.vOddIds = response.data.SeznamJprl;
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.vOddIds = [];
        })
        .then(function () {
          // always executed
        });
    },

    // WS - Výpis Jprl
    NactiJprlVypis: function (Jid) {
      ServiceLhpo.JprlVypis(Jid)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.JprlVypisData = response.data.Vypis;
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.JprlVypisData = null;
        })
        .then(function () {
          // always executed
        });
    },

    // WS - mbr Jprl
    NactiJprlMbr: function (Jid) {
      ServiceLhpo.JprlMbr(Jid)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.$store.commit("SET_sMapMBR", {
              epsg: "EPSG:5514",
              xmin: response.data.Mbr.Xmin,
              ymin: response.data.Mbr.Ymin,
              xmax: response.data.Mbr.Xmax,
              ymax: response.data.Mbr.Ymax,
            });
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          //this.JprlVypisData = null;
        })
        .then(function () {
          // always executed
        });
    },

    // WS - Bbox Jprl
    NactiBboxJprl: function (Jid, EpsgCode, Xmin, Ymin, Xmax, Ymax, SchvStav) {
      ServiceLhpo.BboxJprl(Jid, EpsgCode, Xmin, Ymin, Xmax, Ymax, SchvStav)
        .then((response) => {
          if (response.data.Dokonceno) {
            if (response.data.PocetJprl > 0) {
              // není prázdný seznam, vezme první jid
              this.$store.commit("SET_sVybJprl", {
                JprlID:
                  response.data.Zadani.Jid +
                  "-" +
                  response.data.SeznamJprl[0].Jid,
                ViewVypis: this.vJprlViewVypis,
                ViewOnMap: this.vJprlViewOnMap,
              });
            }
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          //this.JprlVypisData = null;
        })
        .then(function () {
          // always executed
        });
    },

    // Změna Lhc
    ZmenaLhc: function (value) {
      this.vOddIds = [];
      this.JprlVypisData = null;
      if (value.Jid !== null && typeof value.Jid !== "undefined") {
        this.NactiLhcSeznamJprl(value.Jid, value.MajKod);
      }
    },

    // Tisk jprl
    JprlPrint: function (value) {
      if (this.JprlVypisData != null) {
        var _VypisLight = this.VypisLight;
        var _VypisZoom = this.VypisZoom;

        this.VypisLight = true;
        this.VypisZoom = 100;

        var _PrintName = !this.NevybLhcMaj
          ? this.VybLhc.LhcKod +
          " " +
          this.VybLhc.LhcNaz +
          " (" +
          this.VybLhc.MajKod +
          " " +
          this.VybLhc.MajNaz +
          ")"
          : this.VybLhc.LhcKod + " " + this.VybLhc.LhcNaz;

        setTimeout(() => {
          print.PrintObj(
            document.getElementById("PrintAreaTiskHk"),
            _PrintName,
            [value, "printVypisLhpo"]
          );

          this.VypisLight = _VypisLight;
          this.VypisZoom = _VypisZoom;
        }, 1000);
      }
    },
  },

  mounted() {
    // Nastavení služby
    ServiceLhpo.Init(this.AppServiceurl.ServiceLhpo);
    this.ZmenaLhc(this.VybLhc);

    //this.vLhcMajJprl = JprlPokus;
  },
};
</script>

<style >
@import "./common/VypisLhpo.css";
</style>